var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVendor = function SvgVendor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 65 65"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m62.522 28.026-4.447-4.51a3.2 3.2 0 0 1-.96-2.336v-6.398a6.654 6.654 0 0 0-6.717-6.621H44a3.2 3.2 0 0 1-2.335-.96l-4.479-4.51a6.654 6.654 0 0 0-9.404 0l-4.51 4.446a3.2 3.2 0 0 1-2.336.96h-6.398a6.653 6.653 0 0 0-6.622 6.717v6.398a3.2 3.2 0 0 1-.96 2.335l-4.51 4.479a6.654 6.654 0 0 0 0 9.404l4.447 4.51a3.2 3.2 0 0 1 .96 2.336v6.398a6.653 6.653 0 0 0 6.717 6.622h6.398a3.2 3.2 0 0 1 2.335.96l4.51 4.51a6.653 6.653 0 0 0 9.405 0l4.479-4.447a3.2 3.2 0 0 1 2.335-.96h6.398a6.654 6.654 0 0 0 6.654-6.653v-6.398a3.2 3.2 0 0 1 .96-2.335l4.51-4.51a6.654 6.654 0 0 0-.032-9.437",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M43.712 47.155a2.43 2.43 0 0 1-2.175-1.376L32.484 26.33 23.43 45.78a2.4 2.4 0 0 1-3.199 1.151 2.366 2.366 0 0 1-1.152-3.199L30.31 19.644a2.495 2.495 0 0 1 4.35 0L45.887 43.7a2.4 2.4 0 0 1-1.151 3.199 2.3 2.3 0 0 1-1.024.256"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M39.682 38.55H25.255a2.4 2.4 0 0 1 0-4.798h14.427a2.4 2.4 0 0 1 0 4.798"
  })));
};
export default SvgVendor;